import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=97d5170e&scoped=true&"
import script from "./Observer.vue?vue&type=script&lang=js&"
export * from "./Observer.vue?vue&type=script&lang=js&"
import style0 from "./Observer.vue?vue&type=style&index=0&id=97d5170e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d5170e",
  null
  
)

export default component.exports